var _defs, _a;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Square",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "https://www.linkedin.com/in/joshleedev/",
    viewBox: "0 0 141.94 141.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            @import url('http://fonts.cdnfonts.com/css/myriad-pro');\r\n            .cls-1{fill:#fff;stroke:#f3a623;stroke-miterlimit:10;stroke-width:4px;}\r\n            .cls-2{font-size:115px;fill:#f3a623;font-family:Myriad Pro;font-weight:700;cursor: pointer;}\r\n        "))), _a || (_a = /*#__PURE__*/React.createElement("a", {
    target: "_blank",
    xlinkHref: "https://www.linkedin.com/in/joshleedev/"
  }, /*#__PURE__*/React.createElement("title", null, "Linkedin Inverted Yellow"), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2,
    y: 2,
    width: 137.94,
    height: 137.94
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(22.52 105.86)"
  }, "in"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinActive);
export default __webpack_public_path__ + "static/media/linkedin-active.a1647c5c379a2cd4477a1122bc35b110.svg";
export { ForwardRef as ReactComponent };